import axios from 'axios';
import authConfig from '@/../auth_config.json';

let file = axios.create({
    baseURL: authConfig.fileDomain,
})
file.interceptors.request.use(function (config) {
    let language = localStorage.getItem("language");
    if (!language) language = "vi-VN";
    config.headers["Accept-Language"] = language;
    let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
    if (ftpUser) config.headers["Authorization"] = "Bearer " + ftpUser.access_token;
    return config
});
file.interceptors.response.use(function (config) {
        let language = localStorage.getItem("language");
        if (!language) language = "vi-VN";
        config.headers["Accept-Language"] = language;
        let ftpUser = JSON.parse(localStorage.getItem('ftpUser'))
        if (ftpUser) config.headers["Authorization"] = "Bearer " + ftpUser.access_token;
        return config;
    },
    function (error) {
        if (error && error.response.status === 401) {
            localStorage.clear();
            return location.reload();
        }
        return Promise.reject(error)
    })

export default file;
